import type { InvoiceType } from './api';

const TYPE_LETTER: Record<InvoiceType, string> = {
  FACTURA_A: 'A',
  FACTURA_B: 'B',
  FACTURA_C: 'C',
};

/** e.g. `formatInvoiceNumber(4, 'FACTURA_A', 112)` → `"0004-A-00000112"` (`design.md` §9.2's own example). */
export function formatInvoiceNumber(
  pointOfSale: number,
  invoiceType: InvoiceType,
  number: number,
): string {
  const prefix = `${String(pointOfSale).padStart(4, '0')}-${TYPE_LETTER[invoiceType]}`;

  // Drafts carry 0 until ARCA authorises a number; "00000000" would read as a
  // real, already issued invoice.
  if (number <= 0) {
    return `${prefix} · sin número`;
  }

  return `${prefix}-${String(number).padStart(8, '0')}`;
}
